import { useTranslation } from "react-i18next";
import styles from "./Unauthorized.module.scss";

const Unauthorized: React.FC = () => {
  const { t } = useTranslation();

  return <h2 className={styles.unauthorizedMessage}>{t("unauthorizedMessage")}</h2>;
};

export default Unauthorized;
